'use strict';
var localisations = require('../account.localisations');

export default class ForgottenController {
  user = {
    name: '',
    email: '',
    password: ''
  };
  errors = {
    login: undefined
  };
  submitted = false;


  /*@ngInject*/
  constructor(Auth, $location, common, $routeParams, $http) {
    this.Auth = Auth;
    this.$location = $location;
    this.common = common;
    this.common.setPageTitle('');
    this.localisations = localisations[this.common.getLocale()];
    this.sending = false;
    this.email = '';
    this.resetcode = '';
    this.newPassword = '';
    this.confirmPassword = "";
    this.resetCode = $routeParams.code;
    this.qsemail = $routeParams.email;
    this.validCode = false;
    this.message = "";
    this.setNew = false;
    this.linkedSent = false;

    if (typeof this.resetCode !== 'undefined') {
      // Check code and show message if invalid;
      var promise = $http.get('/api/users/' + this.resetCode + '/' + this.qsemail + '/resetpassword');

      promise.then(response => {
        if (response.data) {
          this.email = this.qsemail;
          this.setNew = true;
        }
      }).catch(err => {
          common.setAlert("Error", "danger", "Error checking reset code. Please try again.(Error " + err.status +  ": " + err.statusText + ")", false, true)
      });

    }
  }

  sendRequest(form) {
    var that = this;
    this.submitted = true;

    if(form.$valid && !this.sending) {
      this.sending = true;
      this.common.setQuickNotification('Sending request.', 'info');
      this.Auth.resetPassword(this.email, function(){
        that.common.setQuickNotification('Request sent.', 'success');
        that.linkedSent = true;
        that.sending = false;
      }, function(err){
        that.sending = false;
        that.common.setAlert("Error", "danger", "Unable to process reset request. Please try again.(Error " + err.status +  ": " + err.statusText + ")", false, true);
      });
    }
  }

  resetPassword(form) {
    var that = this;
    this.submitted = true;

    if (form.$valid) {
      this.sending = true;
      this.Auth.resetPasswordSet(this.email, this.resetCode, this.newPassword, function(){
        that.message = "Password reset. Please login.";
        that.sending = false;
      }, function(err){
        that.sending = false;
        that.common.setAlert("Error", "danger", "Error reseting password. Please try again.(Error " + err.status +  ": " + err.statusText + ")", false, true);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/forgotten/forgotten.controller.js